import React, { useState } from 'react'
import { Badge } from "antd";
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import { GeogridPointDrawer } from '../_drawers/GeogridPointDrawer';

const positionDiffBadge = (diff: number | null | undefined) => {
    if (diff == null || diff === 0) return 0;
    const color = diff < 0 ? 'DarkRed' : 'darkgreen';
    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            padding: '0 5px',
            height: 18,
            borderRadius: 10,
            background: color,
            color: 'white',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: 1,
        }}>
            {diff > 0 ? <CaretUpFilled style={{ fontSize: 10 }} /> : <CaretDownFilled style={{ fontSize: 10 }} />}
            {Math.abs(diff)}
        </span>
    );
};

export const MarkerGeoGrid = ({ lat, lng, point, onPointSelect, selected }: any) => {
    
    
    const [panelVisible, setPanelVisible] = useState(false);
    const [geogridPointDrawer, setGeogridPointDrawer] = useState(null);
    
    const handleMouseEnter = () => {
        setPanelVisible(true);                
    };
    
    const handleMouseLeave = () => {
        setPanelVisible(false);                
    };

    const onClick = () => {
        if (onPointSelect) {
            onPointSelect(point);
            return;
        }
        setGeogridPointDrawer(point);   
    }

    const ringStyle = selected
        ? { boxShadow: '0 0 0 4px rgba(15, 23, 42, 0.25), 0 0 0 7px dodgerblue', transform: 'scale(1.12)' }
        : {};

    const diffBadge = point.mainPlace ? positionDiffBadge(point.mainPlace.positionDiff) : 0;

    return (
        <>
        <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)', zIndex: selected || panelVisible ? 100 : 1 }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick} >
            {point.mainPlace ? 
                <Badge size="small" count={diffBadge} style={{ backgroundColor: 'transparent', boxShadow: 'none', padding: 0 }}> 
                    <div style={{ backgroundColor: DOT_COLOR[point.mainPlace.positionPopularity], cursor: 'pointer', color:'white', height: '38px', width: '38px', borderRadius: '50%', border:'solid 2px white', display: 'flex', alignItems: 'center', justifyContent: 'center', ...ringStyle }}>
                        <b>{point.mainPlace.positionPopularity}</b>
                    </div>
                </Badge>
                :            
                point.places?.length > 0 ? 
                <div style={{ backgroundColor: DOT_COLOR[21], cursor: 'pointer', color:'white', height: '38px', width: '38px', borderRadius: '50%', border:'solid 2px white', display: 'flex', alignItems: 'center', justifyContent: 'center', ...ringStyle }}>
                    <b>{'+20'}</b>
                </div>
                :
                <div style={{ backgroundColor: DOT_COLOR[0], cursor: 'pointer', color:'black', height: '38px', width: '38px', borderRadius: '50%', border: selected ? 'solid 2px dodgerblue' : 'solid 1px grey', display: 'flex', alignItems: 'center', justifyContent: 'center', ...ringStyle }}>
                    <b>{'-'}</b>
                </div>
            }
            <div>
            {panelVisible && 
                <div style={{background:'white', borderRadius:'10px', color: 'black', position:'absolute', width:'250px', margin:'5px', padding:'10px', border:'solid grey 1px'}}>                    
                    <b>LOCALPACK</b>
                    <br/><br/>
                    {point?.places.slice(0, 3).map((place: any, index: any) => (
                        <div style={{display:'flex'}} key={index}>
                            <div style={{ backgroundColor: place.reference ? 'black' : DOT_COLOR[index + 1], color:'white', height: '20px', width: '20px', borderRadius: '50%', border:'solid 2px white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {index + 1}                    
                            </div>
                            <div style={{marginLeft:'5px'}}>{place.name}</div>
                        </div>
                    ))}                                                                     
                </div>}                    
            </div>
        </div>
            {!onPointSelect && geogridPointDrawer && <GeogridPointDrawer point={point} onFinish={() => {setGeogridPointDrawer(null);}}/>}	
            </>									
    )
}

export const DOT_COLOR: any = {
    "0": "white",  
    "1": "LimeGreen",  
    "2": "LimeGreen",  
    "3": "LimeGreen",  
    "4": "darkorange", 
    "5": "darkorange", 
    "6": "darkorange", 
    "7": "darkorange", 
    "8": "darkorange", 
    "9": "darkorange", 
    "10": "darkorange",
    "11": "crimson", 
    "12": "crimson", 
    "13": "crimson", 
    "14": "crimson", 
    "15": "crimson", 
    "16": "crimson", 
    "17": "crimson", 
    "18": "crimson", 
    "19": "crimson", 
    "20": "crimson", 
    "21": "silver"    
}
